import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import { HttpUtil } from "../../Utils/http-utils";
import { getNetworkMenuId, getToken } from "../../Utils/types";

export const getUserDetailByIdAction = (id) => () => {
  const url = `${API_URL_WITHOUT_USER}/User/LoginwithToken/${id}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  );
};

export const GetProviderTockenNetwork = (id) => () => {
  const url = `${API_URL_WITHOUT_USER}/Network/GetProviderTokenNetwork?ProviderId=0&ShowAll=true`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: getToken(),
      ApiKey: API_KEY,
      MenuId: getNetworkMenuId()?.menuId,
    }
  );
};
export const addProviderAssitLogAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/Network/AddProviderAssistLog`;
  return HttpUtil.makePOST(
    url,
    e,
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  );
};
